/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import Lottie from 'lottie-react';

import { cssMap, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';

import { Skeleton } from '../../../../common/ui/components/skeleton';
import { useThemeAnimation } from '../../../../common/ui/utils/use-theme-animation';

const styles = cssMap({
	iconsContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
});

const loadLightIconsAnimation = () => {
	return import(
		/* webpackChunkName: "provisioning-icons-light" */
		'../../assets/icons.light.json'
	);
};

const loadDarkIconsAnimation = () => {
	return import(
		/* webpackChunkName: "provisioning-icons-dark" */
		'../../assets/icons.dark.json'
	);
};

export const ProvisioningIconsAnimation = (): JSX.Element => {
	const iconsAnimation = useThemeAnimation(loadLightIconsAnimation, loadDarkIconsAnimation);

	return (
		<Box xcss={styles.iconsContainer}>
			<Skeleton isLoading={!iconsAnimation}>
				<Lottie animationData={iconsAnimation} loop={true} />
			</Skeleton>
		</Box>
	);
};
